import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DatalayerService, HistoryService, NotificationType, RoutedModalBaseComponent, SlottedModalComponent, SvgIconComponent } from '@woolworthsnz/styleguide';
import { ShareModule } from 'ngx-sharebuttons';
import { NgFor } from '@angular/common';

export const RECIPE_SHARE_MODAL_PATH = 'recipe-share';

@Component({
	selector: 'recipe-share-modal',
	templateUrl: './share-modal.component.html',
	styleUrls: ['./share-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [SlottedModalComponent, NgFor, ShareModule, SvgIconComponent]
})
export class ShareModalComponent extends RoutedModalBaseComponent {
	title: string;
	shareLinks: { type: string; text: string }[] = [
		{
			type: 'facebook',
			text: 'Share to Facebook',
		},
		{
			type: 'twitter',
			text: 'Share to Twitter',
		},
		{
			type: 'pinterest',
			text: 'Share to Pinterest',
		},
		{
			type: 'email',
			text: 'Share via Email',
		},
		{
			type: 'copy',
			text: 'Copy Link',
		},
	];

	constructor(
		private titleService: Title,
		protected router: Router,
		protected historyService: HistoryService,
		private datalayerService: DatalayerService,
		protected activatedRoute: ActivatedRoute
	) {
		super(router, activatedRoute, historyService);
	}

	ngOnInit(): void {
		this.title = this.titleService
			.getTitle()
			.replace(/^Countdown \| Easy /, '')
			.replace(/ recipe$/, '');
	}

	close(): void {
		this.datalayerService.trackRecipeEvent(NotificationType.Button, 'RSHARE_close');
		super.close();
	}

	handleShareLinkClick(link: { type: string; text: string }): void {
		// Max of 32 characters for event names
		const eventName = `RSHARE_${link.type}`.substring(0, 32);
		this.datalayerService.trackRecipeEvent(NotificationType.Button, eventName);
		this.close();
	}
}
